import { AlignmentType, ImageRun, Paragraph, TextRun, WidthType } from "docx";
import methodology from '../../../../../../Assests/ReportImages/methodology.png'


const setupMethodology = await fetch(methodology).then(response => response.blob())

const setUpMethodologyImage = new ImageRun({
    type: 'png',
    data: await setupMethodology.arrayBuffer(),
    transformation: {
        width: 559,
        height: 328
    },
});

export function auditMethodology(certInCustomerName, certInApplicationName) {
    return new Paragraph({
        alignment: AlignmentType.JUSTIFIED,
        spacing: { before: 200, after: 300 },
        spacing: { line: 276 },
        children: [
            new TextRun({
                text: "OWASP top 10 2025, Cyber Security Audit Baseline Requirements, Open Source Security Testing Methodology Manual(OSSTMM3), SANS Top 25 and NIST frameworks to execute the" + " " + certInApplicationName + " " + "belonging to" + " " + certInCustomerName + ".",
                size: 24,
                color: "000000",
                font: "Arial",
                bold: false,
                italics: false
            })
        ],
    })
}

export const Methodology = new Paragraph({
    spacing: { before: 350 },
    alignment: AlignmentType.CENTER,
    children: [setUpMethodologyImage]
})

export const accrualPhase = new Paragraph({
    spacing: { before: 150, after: 250 },
    children: [
        new TextRun({
            text: "Accrual Phase",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const accrualPhaseText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 150, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The information gathering stage is about querying a range of sources to determine information that may assist an attacker in gaining access to an organization’s infrastructure. This is a non-intrusive stage where in all the available data is gathered to facilitate the next phases. Apart from the various information gathering tools available on the net, the methods / tools used included:",
            size: 24,
            font: "Arial",
            color: '000000',
            italics: false,
            bold: false
        }),
    ],
})

export const accrualPhasebullet1 = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Spidering the application for generating the sitemap ",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false
        })
    ]
})


export const accrualPhasebullet2 = new Paragraph({
    indent: { left: 600, },
    spacing: { line: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Information gathering about the technologies used in the application ",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false
        })
    ]
})

export const accrualPhasebullet3 = new Paragraph({
    indent: { left: 600 },
    spacing: { line: 276, after: 20 * 72 * 0.05 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            text: "Scanning for the vulnerabilities in the Application",
            size: 24,
            font: "Arial",
            bullet: { level: 0 },
            color: '000000',
            italics: false,
            bold: false
        })
    ]
})